<template>
  <LayoutPage class="news-page">
    <PostsLastAdded
      v-if="lastAddedPosts"
      :posts="lastAddedPosts"
    />
    <PostsFilter
      v-if="!!posts"
      :filters="filters"
      :posts="filterPosts"
      @getLimitPosts="init()"
    />
  </LayoutPage>
</template>

<script>
import LayoutPage from '@/layout/blog'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import PostsLastAdded  from '@/components/Blog/AllPosts/PostsLastAdded/_index'
import PostsFilter from '@/components/Blog/AllPosts/PostsFilter/_index'

export default {
  components: {
    LayoutPage,
    PostsLastAdded,
    PostsFilter
  },
  methods: {
    ...mapActions('blog',{
      getDataPage: 'GET_DATA_BLOG_PAGE'
    }),
    ...mapMutations({
      setData: 'SET_DATA'
    }),
    init() {
      if (this.loading) return
      const hasPosts = !!this.dataPage.posts.length
      this.getDataPage({
        categoryId: 0, 
        limit: hasPosts ? this.dataPage.posts.length + this.limit : this.limit
      })
    }
  },
  computed: {
    ...mapState('blog', {
      limit: state => state.limit,
      loading: state => state.loading
    }),
    ...mapGetters('blog',{
      dataPage: 'GET_DATA_BLOG_PAGE'
    }),
    filters() {
      return this.dataPage && this.dataPage.filters
    },
    posts() {
      return this.dataPage && this.dataPage.posts
    },
    lastAddedPosts() {
      return this.dataPage && this.dataPage.lastAddedPosts
    },
    filterPosts() {
      return this.posts.filter(post => !this.lastAddedPosts.some(el => el.id === post.id))
    }
  },
  created () {
    this.getDataPage({
      categoryId: 0, 
      limit: 0
    })
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  beforeDestroy() {
    this.setData({
      field: 'blog.blogPage.posts',
      data: []
    })
  }
}
</script>
